import { deliveryInstructionApis } from '@apis/deliveryInstructionApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { DeliveryInstructionListQueryParams } from '@models/DeliveryInstruction';

export const useDeliveryInstructionList = createUseQuery(
  (query: DeliveryInstructionListQueryParams) => ['/delivery-instruction/', query],
  (query) => () =>
    deliveryInstructionApis
      .get('/delivery-instruction/', {
        query,
      })
      .then((r) => {
        if (r[404]) {
          return null;
        }
        return r[200];
      }),
);
